import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ExportService } from 'src/app/shared/services/export.service';
import { ExportRequest } from '../odata-filter/models/export-request';
import { ViewContext } from '../odata-filter/models/view-context';
import { DialogDirective } from 'src/shared-app-portal/components/dialog/dialog.directive';
import { CustomReportTemplateService } from 'src/app/shared/services/custom-report-template.service';
import { CustomReportModel } from 'src/app/shared/models/reports/custom-report.model';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-export-confirmation',
  templateUrl: './export-confirmation.component.html',
  styleUrls: ['./export-confirmation.component.scss'],
  standalone: false
})
export class ExportConfirmationComponent implements OnChanges, OnInit {
  @Input() getExportRequest: (isCustomExport: boolean) => ExportRequest;
  @Input() formId: string;
  @Input() disabled: boolean = false;
  @Input() hasIcon: boolean = false;
  @Input() extraDescription: string = '';
  @Input() viewContext: ViewContext;

  @ViewChild('exportQueuedDialog', { static: true }) exportQueuedDialog: DialogDirective;
  @ViewChild('customExportDialog', { static: true }) customExportDialog: DialogDirective;

  constructor(
    private exportService: ExportService,
    private customReportTemplateService: CustomReportTemplateService,
    private formBuilder: FormBuilder
  ) {}

  private _allTemplates: CustomReportModel[] = [];
  public availableTemplates: CustomReportModel[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.viewContext?.currentValue) {
      this.updateAvailableTemplates();
    }
  }

  async ngOnInit() {
    this._allTemplates = await this.customReportTemplateService.getAllTemplates();
    this.updateAvailableTemplates();
  }

  private updateAvailableTemplates() {
    if (!this._allTemplates?.length || !this.viewContext) {
      this.availableTemplates = [];
      return;
    }
    this.availableTemplates = this._allTemplates.filter((template) => {
      return template.reportType === this.viewContext && template.status === 'Active';
    });
  }

  templateForm: FormGroup<{ template: FormControl<CustomReportModel | null> }>;

  exportCustomReportRequest = async () => {
    const request = this.getExportRequest(true);
    if (!request) {
      this.exportService.openSnackBar('Error. Could not get export request.', false);
      return;
    }

    this.templateForm = this.formBuilder.group({
      template: new FormControl<CustomReportModel | null>(null, [Validators.required])
    });
    const isTemplatePicked = await this.customExportDialog.open({
      form: this.templateForm
    });
    if (!isTemplatePicked) {
      return; //modal was cancelled
    }
    const isSuccessfullyRequested = await this.exportService.customExportRequest(
      request.oDataQuery,
      this.templateForm.value.template.id,
      this.viewContext
    );
    if (isSuccessfullyRequested) {
      this.exportQueuedDialog.open();
    }
  };
  exportRequest = async () => {
    const request = this.getExportRequest(false);
    if (!request) {
      this.exportService.openSnackBar('Error. Could not get export request.', false);
      return;
    }

    await this.exportService.exportRequest(request, this.viewContext);

    this.exportQueuedDialog.open();
  };

  exportFormResponses = async () => {
    const request = this.formId;
    const isSuccessfullyRequested = await this.exportService.FormResponsesExportPDFRequest(
      this.formId
    );
    if (isSuccessfullyRequested) {
      this.exportQueuedDialog.open();
    }
  };

  close(clickClose: (input: boolean) => boolean) {
    clickClose(true);
  }
}
